import React from "react";
import Table from "../../components/subcomponents/table";
import Button from "../../components/subcomponents/controls/button";
import FormHeader from "../../components/subcomponents/formheader";
import { connect } from "react-redux";
import race_history from "../../api/race_history";
import race_history_competitors from "../../api/race_history_competitors";
import InputField from "../../components/subcomponents/controls/inputfield";
import SubformDetails from "../../components/subcomponents/subform_details";
import SelectField from "../../components/subcomponents/controls/selectfield";
import CheckField from "../../components/subcomponents/controls/checkfield";

class eventDetailsFeed extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allow_to_edit: false,
    };
  }
  componentDidMount() {
    race_history.details();
    race_history.options();
    race_history_competitors.linked_list();
  }
  cancel() {
    this.setState({ allow_to_edit: false });
    race_history.details();
  }
  saveRec() {
    let self = this;
    if (this.state.allow_to_edit) {
      race_history.update((error) => {
        if (!error) {
          race_history.details();
          self.cancel();
        }
      });
    }
  }
  deleteRec() {
    let self = this;
    race_history.del(function (error) {
      if (!error) {
        self.props.history.replace("/events_list");
      }
    });
  }
  allowEdit(params) {
    this.setState({ allow_to_edit: params.value });
  }
  showRaceDetails() {
    let race_title = "Race details for ID: " + this.props.race_details.id;

    let save_btn = this.state.allow_to_edit ? "enabled" : "hidden";
    let del_btn = this.state.allow_to_edit ? "enabled" : "hidden";

    let inputs_enabled = this.state.allow_to_edit ? "enabled" : "disabled";
    return (
      <SubformDetails title={race_title} className="details width_100">
        <CheckField
          name="allow_to_edit"
          label="Enable edit"
          onChange={this.allowEdit.bind(this)}
          value={this.state.allow_to_edit}
        />
        <InputField
          status={inputs_enabled}
          name="championship"
          label="Event"
          onChange={this.props.fieldChange}
          value={this.props.race_details.championship}
          error={this.props.race_details_validation["championship"]}
        />
        <InputField
          status={inputs_enabled}
          name="name"
          label="Run"
          onChange={this.props.fieldChange}
          value={this.props.race_details.name}
          error={this.props.race_details_validation["name"]}
        />
        <InputField
          status={inputs_enabled}
          name="classes"
          label="Classes"
          onChange={this.props.fieldChange}
          value={this.props.race_details.classes}
          error={this.props.race_details_validation["classes"]}
        />
        <InputField
          status={inputs_enabled}
          name="track_name"
          label="Track name"
          onChange={this.props.fieldChange}
          value={this.props.race_details.track_name}
          error={this.props.race_details_validation["track_name"]}
        />
        <InputField
          status={inputs_enabled}
          name="track_length"
          label="Length, km"
          onChange={this.props.fieldChange}
          value={this.props.race_details.track_length}
          error={this.props.race_details_validation["track_length"]}
        />
        <InputField
          name="start_time"
          status={inputs_enabled}
          label="Started"
          onChange={this.props.fieldChange}
          value={this.props.race_details.start_time}
          input_control={{
            numericOnly: true,
            delimiters: [":"],
            blocks: [2, 2],
          }}
          placeholder="HH:mm"
          error={this.props.race_details_validation["start_time"]}
        />
        <InputField
          name="end_time"
          status={inputs_enabled}
          label="Finished"
          onChange={this.props.fieldChange}
          value={this.props.race_details.end_time}
          input_control={{
            numericOnly: true,
            delimiters: [":"],
            blocks: [2, 2],
          }}
          placeholder="HH:mm"
          error={this.props.race_details_validation["end_time"]}
        />
        <SelectField
          status={inputs_enabled}
          name="race_type_id"
          label="Type"
          options={this.props.race_details_options["race_type_id"]}
          onChange={this.props.fieldChange}
          value={this.props.race_details.race_type_id}
          error={this.props.race_details_validation["role_type_id"]}
        />
        <SelectField
          status={inputs_enabled}
          name="company_id"
          label="Company"
          options={this.props.race_details_options["company_id"]}
          onChange={this.props.fieldChange}
          value={this.props.race_details.company_id}
          error={this.props.race_details_validation["company_id"]}
        />

        <div className="toolbar">
          <Button
            name="add"
            label="Update race"
            onClick={this.saveRec.bind(this)}
            status={save_btn}
          />
          <Button
            name="delete"
            label="Delete race"
            onClick={this.deleteRec.bind(this)}
            status={del_btn}
          />
          <Button
            name="cancel"
            label="Cancel"
            onClick={this.cancel.bind(this)}
            status={save_btn}
          />
        </div>
      </SubformDetails>
    );
  }

  showCompetitorsList() {
    let sort_by_bl = false;
    let t_header = {};

    if (this.props.race_details.race_type_id) {
      sort_by_bl = this.props.race_details.race_type_id === 1 ? true : false;
    } else {
      sort_by_bl = this.props.sort_by_bl;
    }

    if (sort_by_bl && this.props.race_competitors_list) {
      t_header = {
        position_by_time: { label: "Position", width: "3%" },
        nr: { label: "Nr", width: "3%" },
        firstname: { label: "F.name", width: "10%" },
        lastname: { label: "L.name", width: "10%" },
        state: { label: "State", width: "3%" },
        state2: { label: "State 2", width: "3%" },
        class: { label: "Class", width: "10%" },
        team: { label: "Team/Club", width: "14%" },
        sponsor: { label: "Sponsor", width: "5%" },
        make: { label: "Make", width: "8%" },
        model_engine: { label: "Model", width: "5%" },
        tires: { label: "Tires", width: "3%" },
        hometown: { label: "Hometown", width: "5%"},
        lap: { label: "Laps", width: "3%" },
        best_lap_time: { label: "BestTm", width: "5%" },
        diff_by_time: { label: "Diff", width: "5%" },
        gap_by_time: { label: "Gap", width: "5%" },
      };
    } else {
      t_header = {
        position_by_lap: { label: "Position", width: "3%" },
        nr: { label: "Nr", width: "3%" },
        firstname: { label: "F.name", width: "10%" },
        lastname: { label: "L.name", width: "10%" },
        state: { label: "State", width: "3%" },
        state2: { label: "State 2", width: "3%" },
        class: { label: "Class", width: "10%" },
        team: { label: "Team/Club", width: "12%" },
        sponsor: { label: "Sponsor", width: "5%" },
        make: { label: "Make", width: "8%" },
        model_engine: { label: "Model", width: "5%" },
        tires: { label: "Tires", width: "3%" },
        hometown: { label: "Hometown", width: "5%"},
        lap: { label: "Laps", width: "3%" },
        diff_by_lap: { label: "Diff", width: "5%" },
        gap_by_lap: { label: "Gap", width: "5%" },
        best_lap_time: { label: "BestTm", width: "5%" },
        finished_time: { label: "FinishTm", width: "5%" },
      };
    }

    return (
      <SubformDetails title="Competitors" className="details width_100">
        <div className="module_block_wrap">
          <Table
            name="events_details"
            table_key={"nr"}
            table_class="compact"
            headers={t_header}
            data={this.props.race_competitors_list}
          />
        </div>
      </SubformDetails>
    );
  }
  render() {
    return (
      <div className="form_wrap race_event_details">
        <FormHeader title="RACE HISTORY DETAILS" />
        {this.showRaceDetails()}
        {this.showCompetitorsList()}
      </div>
    );
  }
}

function stateArr(obj = {}) {
  let state_arr = [];
  Object.keys(obj).forEach((field) => {
    state_arr.push(obj[field]);
  });
  return state_arr;
}

function mapStateToProps(state) {
  let history_events = state.raceR.history_events;
  return {
    search_string: history_events.search_string,
    race_details: history_events.details,
    race_competitors_list: history_events.competitors,
    sort_by_bl: state.raceR.sort_by_bl,
    sort_by_class: state.raceR.sort_by_class,
    refresh: stateArr(history_events.details),
    race_details_validation: history_events.validation,
    race_details_options: history_events.options,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fieldChangeSort(result) {
      dispatch({
        type: "RACE_RESULT_SORT",
        field: result.name,
        value: result.value,
      });
    },
    fieldChange(result) {
      dispatch({
        type: "RACE_HISTORY_UPDATE_FORM",
        field: result.name,
        value: result.value,
      });
    },
  };
}

export default eventDetailsFeed = connect(
  mapStateToProps,
  mapDispatchToProps
)(eventDetailsFeed);
